import { WidgetKeys } from "mobx-store/stores/customScreens/types";
import { ValidationOptionsKeys } from "../types";
import { gneralWidgetValidation } from "../widgetsCardData/generalWidgetCard/types";
import { occupancyWidgetValidation } from "./clubOccupancyWidgetCard/types";
import { descriptionWidgetValidation } from "./descriptionWidgetCard/types";
import { homePointsWidgetValidation } from "./HomePointsWidgetCard/types";
import { horizontalWidgetValidation } from "./horizontalWidgetCard/types";
import { iconWidgetValidation } from "./iconWidgetCard/types";
import { imageWidgetValidation } from "./imageWidgetCard/types";
import { tabWidgetValidation } from "./tabWidgetCard/types";
import { thumbnailWidgetValidation } from "./thumbnailWidgetCard/types";
import { titleWidgetValidation } from "./titleWidgetCard/types";
import { verticalWidgetValidation } from "./verticalWidgetCard/types";


type WidgetForm = {[key in string]: string};
interface ValidationCase {
    key: string,
    value: string | boolean;
}
interface ValidationOption {
    validation: ValidationOptionsKeys[],
    case?: ValidationCase;
}
export interface ValidationSchema {
    [key: string]: ValidationOption[];
}

export interface ValidFormResponse {
    valid: boolean,
    key?: string,
    message?: string;
}
type Validation = {[key in WidgetKeys]: ValidationSchema | null};
export const validations: Validation = {
    [WidgetKeys.GENERAL_WIDGET]: gneralWidgetValidation,
    [WidgetKeys.HORIZONTAL_WIDGET]: horizontalWidgetValidation,
    [WidgetKeys.VERTICAL_WIDGET]: verticalWidgetValidation,
    [WidgetKeys.IMAGE_WIDGET]: imageWidgetValidation,
    [WidgetKeys.ICON_WIDGET]: iconWidgetValidation,
    [WidgetKeys.CLUB_OCCUPANCY_WIDGET]: occupancyWidgetValidation,
    [WidgetKeys.THUMBNAIL_WIDGET]: thumbnailWidgetValidation,
    [WidgetKeys.TITLE_WIDGET]: titleWidgetValidation,
    [WidgetKeys.TAB_WIDGET]: tabWidgetValidation,
    [WidgetKeys.DESCRIPTION_WIDGET]: descriptionWidgetValidation,
    [WidgetKeys.ACCOUNT_CONTROL_WIDGET]: null,
    [WidgetKeys.HEADER_INFO_WIDGET]: null,
    [WidgetKeys.POINTS_WIDGET]: null,
    [WidgetKeys.SLIDER_WIDGET]: null,
    [WidgetKeys.NO_POINTS_WIDGET]: null,
    [WidgetKeys.HOME_POINTS_WIDGET]: homePointsWidgetValidation,
    [WidgetKeys.CARD_RECEIVAL_WIDGET]: null,
};

export const getFormErrorState = (widgetKey: WidgetKeys,formValues: WidgetForm ): ValidFormResponse => {
    console.log('widgetKey' , widgetKey)
    console.log('formvalues' , formValues)
    const validation = validations[widgetKey];
    if(!validation || !formValues) {
        return getValidFormResponse(true);
    }
    const validationKeys = Object.keys(validation);
    for (let validationKey of validationKeys) {
        if(!(validationKey in formValues)) {
            formValues[validationKey] = '';
        }
        const validationOptions = validation[validationKey];
        const validForm = validateForm(validationOptions,validationKey, formValues);
        if(!validForm.valid) {
            return validForm;
        }
    }
    return getValidFormResponse(true);
}
const validateForm = (
    validationOptions: ValidationOption [],
    validationKey: string, 
    formValues: WidgetForm
): ValidFormResponse => {
    const validationOptionsKeys = Object.keys(validationOptions);
    for(let vok in validationOptionsKeys) {
        if(validationOptions[vok].case) {
            const formDependentValue = formValues[validationOptions[vok].case!.key];
            if(formDependentValue === validationOptions[vok].case?.value) {
                const errorKey =  validateOptionsCases(validationOptions[vok], formValues[validationKey]);
                if(errorKey) {
                    return getValidFormResponse(false, validationKey , errorKey);
                }
            }
        } else {
            const errorKey =  validateOptionsCases(validationOptions[vok], formValues[validationKey]);
            if(errorKey) {
                return getValidFormResponse(false, validationKey , errorKey);
            }
        }
    }
    return getValidFormResponse(true);
};

const validateOptionsCases = (validationOption: ValidationOption, value: string ):ValidationOptionsKeys | null  => {
    if(validationOption.validation.includes(ValidationOptionsKeys.REQUIRED)) {
        if(!`${value}`.length) {
            return ValidationOptionsKeys.REQUIRED;
        }
    }
    return null;
};

const getValidFormResponse = (valid: boolean, key?: string, message?: string): ValidFormResponse  =>{
    return {
        key,
        message,
        valid
    };
}